import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  toastError,
  toastSuccess,
  airCompressedconsumptionId,
  BarActionId,
  CFMActionId,
  formatAmount,
} from "../../../../../utils/constants";
import {
  insertUpdateAirConnection_action,
  getAirConnectionDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/airConnection_action/airConnection_action";
import $ from "jquery";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import { fill_action } from "../../../../../actions/fillCombo_action";
import moment from "moment";
import VendorDrawer from "../../../../../common_components/vendor_module_drawer";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDetails from "../../vendorDetails";

class AirConnectionApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      PowerConnectionList: [],
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      Is_Agree: false,
      Remark: "",
      CGST: 0,
      SGST: 0,
      Is_AgreeErr: "",
      DeadlineDate: "",
      Is_Required: true,
      carPassessId: "",
      currentDate: moment().format("DD-MM-YYYY"),
      tableData: "",
      airConsumptionQuantity: "",
      IGST: "",
      Is_View: false,
      CompressedAirConsumptionID: 1,
      MaxCompressedQuantity: "",
      Quantity: "",
      TotalAmount: 0,
      airCompressedconsumptionList: [],
      DescriptionOfService: "",
      Rates: "",
      Amount: "",
      ServiceID: "",
      StatusID: "",
      BarId: 1,
      BarList: "",
      CFMId: 1,
      CFMList: "",
      BarQuantity_6: "",
      BarQuantity_7_to_30: "",
      // PricingArray: [
      //   {
      //     Description: "5-6 Bar Pressure with 0 TO 10 CFM",
      //     srNo: "A)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 1,
      //   },
      //   {
      //     Description: "5-6 Bar Pressure with 11 TO 20 CFM",
      //     srNo: "B)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 1,
      //   },
      //   {
      //     Description: "5-6 Bar Pressure with 21 TO 30 CFM",
      //     srNo: "C)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 1,
      //   },
      //   {
      //     Description: "5-6 Bar Pressure with 31 TO 40 CFM",
      //     srNo: "D)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 1,
      //   },
      //   {
      //     Description: "5-6 Bar Pressure with 41 TO 50 CFM",
      //     srNo: "E)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 1,
      //   },
      //   {
      //     Description: "",
      //     srNo: "",
      //     price: "",
      //     Connection: "",
      //     id: "",
      //   },
      //   {
      //     Description: "7 Bar Pressure with 0 TO 10 CFM",
      //     srNo: "A)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 2,
      //   },
      //   {
      //     Description: "7 Bar Pressure with 11 TO 20 CFM",
      //     srNo: "B)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 2,
      //   },
      //   {
      //     Description: "7 Bar Pressure with 21 TO 30 CFM",
      //     srNo: "C)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 2,
      //   },
      //   {
      //     Description: "7 Bar Pressure with 31 TO 40 CFM",
      //     srNo: "D)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 2,
      //   },
      //   {
      //     Description: "7 Bar Pressure with 41 TO 50 CFM",
      //     srNo: "E)",
      //     price: 0,
      //     Connection: "Each Conn.",
      //     id: 2,
      //   },
      // ],
      PricingArray: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      CurrencyID: null,
      // isHideSection: sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 16
      // isHideSection:true,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      IsIGST: false,
      isDisableMaxCompress: false,
      isDisableBarId: false,
      isDisableCFMId: false,
    };
    // this.getPowerConnectionList = this.getPowerConnectionList.bind(this)
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addAirConnection()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.getFillList(airCompressedconsumptionId, "", "", "", "");
    this.getFillList(BarActionId, "", "", "", "");
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      Is_View:
        this.props.location.state != null && this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
      StatusID:
        this.props.location.state != null && this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : "",
    });
    setTimeout(() => {
      this.getAirConnectionDetails();
      console.log(
        "Deadline Date:------------------------------------------------------>",
        this.state.DeadlineDate
      );
    }, 200);

    this.loadscript();
    console.log("this.props.location.state", this.props.location.state);
  }
  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value) {
    // this.setState({ isLoading: true })
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // country list
          if (actionID === airCompressedconsumptionId) {
            data.data.map((item, i) => {
              if (i == 0) {
                item.Is_checked = 1;
              } else {
                item.Is_checked = 0;
              }
            });
            this.setState({
              airCompressedconsumptionList: data.data,
            });
          }
          if (actionID === BarActionId) {
            this.setState({
              BarList: data.data,
            });
          }
          if (actionID === CFMActionId) {
            this.setState({
              CFMList: data.data
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleCancel() {
    window.history.back();
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false || Is_Agree == null) {
      this.setState({
        Is_AgreeErr: "kindly agree the above mentioned clauses & consequences.",
      });
    }
  }

  getAirConnectionDetails() {
    const {
      Remark,
      Is_Agree,
      isQuantity,
      Is_Required,
      airCompressedconsumptionList,
      PricingArray,
    } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getAirConnectionDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            isLoading: false,
            IsIGST: data.IGST[0]['IsIGST']
          });

          if (data.data != "") {
            this.setState({
              CurrencyID: data.ChargesList[0]["CurrencyID"],
              Remark: data.data[0]["Remark"],
              Is_Agree: data.data[0]["Is_Agree"],
              DescriptionOfService: data.data[0]["DescriptionOfService"],
              Rates: data.data[0]["Rates"],
              Amount: data.data[0]["Amount"],
              ServiceID: data.data[0]["ServiceID"],
              CGST: data.data[0]["CGST"] * 100,
              SGST: data.data[0]["SGST"] * 100,
              IGST: data.data[0]["IGST"] * 100,
              totalAmount:
                data.data[0]["Amount"] != "" && data.data[0]["Amount"] != null
                  ? data.data[0]["Amount"]
                  : 0,
              airConsumptionQuantity: data.data[0]["airConsumptionQuantity"],
              MaxCompressedQuantity: data.data[0]["NoOfConnection"],
              Quantity: data.data[0]["Quantity"],
              BarId: data.data[0]["BarQuantity"] != null ? data.data[0]["BarQuantity"] : 1,
              CFMId: data.data[0]["CFMQuantity"] != null ? data.data[0]["CFMQuantity"] : 1,
            }, () => {
              this.getFillList(CFMActionId, "", this.state.BarId <= 6 ? 13 : this.state.BarId == 7 ? 14 : 17, "", data.data[0]["BarQuantity"] != null ? data.data[0]["BarQuantity"] : 1);
            });

            if (data.data[0]["CompressedAirConsumptionID"] != null) {
              console.log(
                "airCompressedconsumptionList1122",
                this.state.airCompressedconsumptionList
              );
              // this.state.airCompressedconsumptionList.map((item) => {
              //     if (data.data[0]['CompressedAirConsumptionID'] == item.CompressedAirConsumptionID) {
              //         item.Is_checked = 1
              //         this.setState({
              //             CompressedAirConsumptionID: item.CompressedAirConsumptionID
              //         })
              //     } else {
              //         item.Is_checked = 0
              //     }
              // })
              // this.setState({
              //     airCompressedconsumptionList: this.state.airCompressedconsumptionList
              // })
            }
          } else {
            this.getFillList(CFMActionId, "", 13, "", 1)
            this.setState({
              CurrencyID: data.ChargesList[0]["CurrencyID"],
              Amount: data.ChargesList[0]["Rates"],
              totalAmount: data.ChargesList[0]["Rates"],
              Rates: data.ChargesList[0]["Rates"],
              ServiceID: data.ChargesList[0]["ServiceID"],
              CGST: data.ChargesList[0]["CGST"] * 100,
              SGST: data.ChargesList[0]["SGST"] * 100,
              IGST: data.ChargesList[0]["IGST"] * 100,
              MaxCompressedQuantity: data.IGST[0]['defaultConnection'] != 0 ? data.IGST[0]['defaultConnection'] : 1,
              BarId: data.IGST[0]['defaultBar'] != 0 ? data.IGST[0]['defaultBar'] : 1,
              CFMId: data.IGST[0]['defaultCFM'] != 0 ? data.IGST[0]['defaultCFM'] : 1,
              isDisableMaxCompress: data.IGST[0]['defaultConnection'] != 0 ? true : false,
              isDisableBarId: data.IGST[0]['defaultBar'] != 0 ? true : false,
              isDisableCFMId: data.IGST[0]['defaultCFM'] != 0 ? true : false,
            });
          }

          var price = 0;
          var price2 = 0;
          var flag = true;
          // for (let i = 0; i < PricingArray.length; i++) {
          //   if (PricingArray[i]["id"] == 1) {
          //     price += data.ChargesList[0]["Rates"];
          //     PricingArray[i]["price"] = price;
          //   }

          //   if (PricingArray[i]["id"] == 2) {
          //     price2 += data.ChargesList[1]["Rates"];
          //     PricingArray[i]["price"] = price2;
          //   }
          // }
          this.setState({ PricingArray: data.ChargesList });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addAirConnection() {
    const {
      Remark,
      Is_Agree,
      Amount,
      MaxCompressedQuantity,
      ServiceID,
      Rates,
      Quantity,
      CompressedAirConsumptionID,
      CFMId,
      BarId,
      NoOfConnection,
    } = this.state;
    console.log("Values being sent:", {
      Remark,
      Is_Agree,
      CFMId,
      MaxCompressedQuantity,
      CompressedAirConsumptionID,
      ServiceID,
      Rates,
      Amount,
      BarId,
    });
    const array = [];
    array.push({
      ServiceID: ServiceID,
      Rates: Rates,
      Quantity: Quantity,
      Amount: Amount,
    });
    this.inputValidate();

    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID2 = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    this.setState({ isLoading: true });
    console.log("ServiceID2-->", ServiceID2);
    // Remark, Is_Agree, Quantity, NoofConnection, CompressedAirConsumptionID, AirConnectionList
    if (Is_Agree) {
      if (MaxCompressedQuantity != 0 && MaxCompressedQuantity?.trim() != '' && MaxCompressedQuantity != null) {
        this.props
          .insertUpdateAirConnection_action(
            Remark,
            Is_Agree,
            CFMId,
            MaxCompressedQuantity,
            CompressedAirConsumptionID,
            ServiceID,
            Rates,
            Amount,
            BarId,
            ManualFormsID,
            ServiceID2,
            VendorDetails
          )
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toastSuccess(
                this.state.StatusID == 0
                  ? "Air Connection Form Submitted Successfully"
                  : "Air Connection Form Updated Successfully"
              );
              setTimeout(() => {
                this.props.navigate("/manualForms");
              }, 2000);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        toastError("Plase enter max compressed air quantity!");
        this.setState({ isLoading: false });
      }
    } else {
      toastError("Plase enter mandatory feilds!");
      this.inputValidate();
      this.setState({ isLoading: false });
    }
  }

  onQuantity(e, index) {
    const { tableData } = this.state;
    const event = e.target.value.replace(/\D/, "");
    tableData.map((data, i) => {
      if (i === index) {
        if (event != "") {
          data.Quantity = event;
          data.Amount = event * data.Rates;
        } else {
          data.Quantity = "";
          data.Amount = data.Rates;
        }
      }
    });
    const totalAmount = this.sumOfObject(tableData, "Amount");
    this.setState({ tableData: tableData, totalAmount: totalAmount });
  }

  sumOfObject(arrayOfObjects, propertyName) {
    return arrayOfObjects.reduce((accumulator, currentObject) => {
      return accumulator + currentObject[propertyName];
    }, 0);
  }

  onAirCompressureSelect(e, index) {
    const { airCompressedconsumptionList } = this.state;
    const value = e.target.checked;
    airCompressedconsumptionList.map((item, i) => {
      if (i == index) {
        item.Is_checked = 1;
        this.setState({
          CompressedAirConsumptionID: item.CompressedAirConsumptionID,
        });
      } else {
        item.Is_checked = 0;
      }
    });
  }

  onairConsumptionQuantity(e) {
    const { Rates } = this.state;
    if (e.target.value != "") {
      this.setState({
        airConsumptionQuantity: e.target.value.replace(/\D/, ""),
        Amount: e.target.value * Rates,
        totalAmount: e.target.value * Rates,
      });
    } else {
      this.setState({ airConsumptionQuantity: "", Amount: 0, totalAmount: 0 });
    }
  }

  onBarQuantity = (e) => {
    const selectedBar = Number(e.target.value);
    const { PricingArray } = this.state;

    // API call (unchanged)
    this.getFillList(
      CFMActionId,
      "",
      selectedBar <= 6 ? 13 : selectedBar === 7 ? 14 : 17,
      "",
      selectedBar
    );

    // Determine bar text
    let barValue = "";
    if (selectedBar <= 6) {
      barValue = "Upto 6 bar";
    } else if (selectedBar == 7) {
      barValue = "7 bar";
    } else if (selectedBar == 8) {
      barValue = "8 bar";
    }

    // Get pricing slabs for this bar
    const eligiblePrices = PricingArray
      .filter(item => item.BarQuantity == barValue)
      .sort((a, b) => Number(a.CFMQuantity) - Number(b.CFMQuantity));

    // Default to first slab (CFM = 1)
    let Price = eligiblePrices.length ? eligiblePrices[0].Rates : 0;

    this.setState({
      BarId: selectedBar,
      MaxCompressedQuantity: 1,
      Amount: Price,
      totalAmount: Price,
      Rates: Price,
      CFMId: 1
    });
  };

  onCFM_Qantity(e) {
    const { BarId, PricingArray } = this.state;

    const cfm = Number(e.target.value);
    let Price = 0;

    // ✅ correct bar selection
    let barValue = "";

    if (BarId <= 6) {
      barValue = "Upto 6 bar";
    } else if (BarId == 7) {
      barValue = "7 bar";
    } else if (BarId == 8) {
      barValue = "8 bar";
    }

    const eligiblePrices = PricingArray
      .filter(item => item.BarQuantity == barValue)
      .sort((a, b) => Number(a.CFMQuantity) - Number(b.CFMQuantity));

    const matchedItem = eligiblePrices.find(
      item => cfm <= Number(item.CFMQuantity)
    );

    if (matchedItem) {
      Price = matchedItem.Rates;
    }

    this.setState({ CFMId: e.target.value, Rates: Price, MaxCompressedQuantity: 1, Amount: 1 * Price, totalAmount: 1 * Price }, () => {
      // if (e.target.value <= 10) {
      //   this.setState({
      //     MaxCompressedQuantity: 1,
      //     Amount: 1 * Price,
      //     totalAmount: 1 * Price,
      //   });
      // } else if (e.target.value < 21) {
      //   this.setState({
      //     MaxCompressedQuantity: 2,
      //     Amount: 2 * Price,
      //     totalAmount: 2 * Price,
      //   });
      // } else if (e.target.value < 31) {
      //   this.setState({
      //     MaxCompressedQuantity: 3,
      //     Amount: 3 * Price,
      //     totalAmount: 3 * Price,
      //   });
      // } else if (e.target.value < 41) {
      //   this.setState({
      //     MaxCompressedQuantity: 4,
      //     Amount: 4 * Price,
      //     totalAmount: 4 * Price,
      //   });
      // } else if (e.target.value < 51) {
      //   this.setState({
      //     MaxCompressedQuantity: 5,
      //     Amount: 5 * Price,
      //     totalAmount: 5 * Price,
      //   });
      // } else if (e.target.value < 61) {
      //   this.setState({
      //     MaxCompressedQuantity: 6,
      //     Amount: 6 * Price,
      //     totalAmount: 6 * Price,
      //   });
      // } else if (e.target.value < 71) {
      //   this.setState({
      //     MaxCompressedQuantity: 7,
      //     Amount: 7 * Price,
      //     totalAmount: 7 * Price,
      //   });
      // } else if (e.target.value < 81) {
      //   this.setState({
      //     MaxCompressedQuantity: 8,
      //     Amount: 8 * Price,
      //     totalAmount: 8 * Price,
      //   });
      // } else if (e.target.value < 91) {
      //   this.setState({
      //     MaxCompressedQuantity: 9,
      //     Amount: 9 * Price,
      //     totalAmount: 9 * Price,
      //   });
      // } else if (e.target.value <= 100) {
      //   this.setState({
      //     MaxCompressedQuantity: 10,
      //     Amount: 10 * Price,
      //     totalAmount: 10 * Price,
      //   });
      // }
    });
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      airConsumptionQuantity,
      tableData,
      totalAmount,
      IGST,
      Is_View,
      CurrencyID,
      CompressedAirConsumptionID,
      MaxCompressedQuantity,
      Quantity,
      TotalAmount,
      airCompressedconsumptionList,
      DescriptionOfService,
      Rates,
      Amount,
      CGST,
      SGST,
      StatusID,
      BarList,
      BarId,
      CFMId,
      CFMList,
      BarQuantity_6,
      BarQuantity_7_to_30,
      PricingArray,
      RoleID,
      isHideSection,
      IsIGST, isOpenConfirmationModal,
      isDisableMaxCompress,
      isDisableBarId,
      isDisableCFMId,
    } = this.state;

    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    console.log("props", this.props);
    console.log("Current Date:", currentDate);
    console.log("Deadline Date:", DeadlineDate);
    console.log("Is Deadline Passed:", isDeadlinePassed);
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorDrawer />
            ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div
          className={!isHideSection ? "with-dr-container" : ""}
          style={{ marginTop: RoleID == 1 ? "0px" : "" }}
        >
          <div className="">
            {!isHideSection && (
              <div className="row">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}
            <div className="exb-top-space">
              <div className="row">
                <div class="card rounded-0 pt-1 shadow-none mt-3">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px" }}>
                      Air Compressor
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {!isHideSection && (
                      <>
                        <ul
                          style={{
                            lineHeight: "25px",
                            textAlign: "left",
                            padding: 0,
                          }}
                        >
                          <li>
                            1){" "}
                            <strong>
                              Exhibitors are not permitted to use their own compressors for
                              exhibiting their products.{" "}
                            </strong>
                            A maximum pressure of 7 bar would be made available during the
                            exhibition through ½ inch ball valve. Exhibitors must specify the volume
                            of compressed air required by their exhibits.{" "}
                            <strong>
                              However, exhibitors who wish to require pressure more than 7 bar,
                              subject to the confirmation from official agency appointed by INDIA
                              ITME Society at an additional cost, if facility is provided.
                            </strong>
                          </li>
                          <li>
                            2) Compressed air connection will be made available on pillars near
                            stall or at any one corner of the stall.
                          </li>
                          <li>
                            3) Organisers reserve the right to determine the compressed air to be
                            apportioned for the direct/indirect Exhibitors and Exhibitors should
                            agree to abide by such observations and remit charges to organisers
                            accordingly.
                          </li>
                        </ul>
                        <ol style={{ listStyleType: "1", textAlign: "left" }}>
                          <li>
                            All compressors will be located outside the booth to avoid noise
                            pollution, with a tube and stop valve provided at the booth itself.
                          </li>
                          <li>Supply of air is not totally “clean” and “dry”.</li>
                          <li>
                            Exhibitor's should inform their compressed air connection/s requirements
                            along with the payment towards compress air connection/s charges before{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </li>
                          <li>
                            We cannot guarantee provision of orders received after{" "}
                            <strong>
                              {" "}
                              deadline (
                              {this.props.location?.state?.ActualDeadline
                                ? moment(this.props.location.state.ActualDeadline).format(
                                  "DD-MM-YYYY"
                                )
                                : "-"}
                              )
                            </strong>
                            .
                          </li>
                          <li>
                            If details of requirements along with the payment from Exhibitors ,
                            received by INDIA ITME Society after
                            <strong>
                              {" "}
                              deadline (
                              {this.props.location?.state?.ActualDeadline
                                ? moment(this.props.location.state.ActualDeadline).format(
                                  "DD-MM-YYYY"
                                )
                                : "-"}
                              ), then additional surcharge of 25% of basic rates shall be applicable
                              to the Exhibitors.
                            </strong>
                            .
                          </li>
                        </ol>
                        {/* <div style={{ textAlign: "left" }}>
                          <strong>
                            The tariff for Compressed Air connection/s will be as under:
                          </strong>
                          <ol style={{ listStyleType: "1", textAlign: "left" }}>
                            {CurrencyID == 1 ? (
                              <ul
                                style={{
                                  listStyleType: "circle",
                                  textAlign: "left",
                                }}
                              >
                                <li>
                                  <strong>Rs {BarQuantity_6}/-</strong> per connection upto 6 Bar
                                  pressure
                                </li>
                                <li>
                                  <strong>Rs {BarQuantity_7_to_30}/-</strong> per connection of 7
                                  Bar pressure Plus GST @ 18% (as per Government rule) or as
                                  applicable is payable with all the payments will not be refunded.
                                </li>
                              </ul>
                            ) : (
                              <ul
                                style={{
                                  listStyleType: "circle",
                                  textAlign: "left",
                                }}
                              >
                                <li>
                                  <strong>US Dollar {BarQuantity_6}/-</strong> per connection upto 6
                                  Bar pressure
                                </li>
                                <li>
                                  <strong>US Dollar {BarQuantity_7_to_30}/-</strong> per connection
                                  from 7 Bar to 30 Bar pressure Plus GST @ 18% (as per Government
                                  rule) or as applicable is payable with all the payments will not
                                  be refunded.
                                </li>
                              </ul>
                            )}
                          </ol>
                        </div> */}
                      </>
                    )}
                    <VendorDetails />
                    {!isHideSection && (
                      <div className="row mt-3">
                        <h6>
                          Air Compressor Application{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}

                    {!isHideSection && (
                      <div class="table-responsive mt-3">
                        <table class="table border text-nowrap text-md-nowrap table-bordered mb-0  w-50 air-connection-table">
                          <thead>
                            <tr>
                              <th className="text-center" style={{ width: "5%" }}>
                                Sr No{" "}
                              </th>
                              <th className="text-left" style={{ width: "45%" }}>Description</th>
                              <th className="text-center">Bar</th>
                              <th className="text-center">CFM</th>
                              {!isHideSection &&
                                (CurrencyID == 1 ? (
                                  <th className="text-center">
                                    For National Exhibitor <br></br>Amt. (INR)
                                  </th>
                                ) : (
                                  <th className="text-center">
                                    For International Exhibitor <br></br>Amt. (USD)
                                  </th>
                                ))}
                              <th className="text-center">Connection</th>
                            </tr>
                          </thead>
                          <tbody>
                            {PricingArray.map((item, i) => (
                              <tr>
                                <td className="text-center">{i + 1}</td>
                                <td className="text-left" style={{ whiteSpace: "pre-line" }}>{item.DescriptionOfService}</td>
                                <td className="text-center">{item.BarQuantity}</td>
                                <td className="text-center">{item.CFMQuantity}</td>
                                {!isHideSection && (
                                  <td style={{ textAlign: "right" }}>
                                    {item.Rates ? formatAmount(item.Rates) : ""}
                                  </td>
                                )}
                                <td className="text-center">Each Conn.</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div class="table-responsive mt-3">
                      {!isHideSection && (
                        <p className="m-0">
                          For more details or any queries please contact: itme@india-itme.com
                        </p>
                      )}
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1"></table>
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-5">
                        <thead>
                          <tr>
                            <th style={{}} colSpan={2}>
                              Description of Service
                            </th>
                            <th style={{}}>Type of Compressed Air consumption</th>
                            <th style={{}} colSpan={2}>
                              Quantity
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={2}>{DescriptionOfService}</td>
                            <td>
                              <div className="d-flex" style={{ flexDirection: "column" }}>
                                {console.log(
                                  "airCompressedconsumptionList",
                                  airCompressedconsumptionList
                                )}
                                <div>
                                  {airCompressedconsumptionList.map((data, i) => (
                                    <>
                                      <input
                                        type="radio"
                                        style={{
                                          cursor: !Is_View ? "pointer" : "default",
                                        }}
                                        checked={data.Is_checked == 1}
                                        onChange={(e) => this.onAirCompressureSelect(e, i)}
                                        maxLength={10}
                                        disabled={Is_View || isDeadlinePassed || StatusID == 2}
                                      />
                                      <strong>
                                        {" "}
                                        {data.Type} <br />{" "}
                                      </strong>
                                    </>
                                  ))}
                                </div>
                              </div>
                            </td>
                            <td colSpan={2}>
                              {/* <input type="text" className="form-control"
                                                                value={airConsumptionQuantity}
                                                                onChange={(e) => this.onairConsumptionQuantity(e)}
                                                                maxLength={10}
                                                                disabled={Is_View}
                                                            /> */}
                              <label>Bar Quantity</label>
                              <select
                                className="form-control"
                                value={BarId}
                                onChange={(e) => this.onBarQuantity(e)}
                                disabled={Is_View || isDeadlinePassed || StatusID == 2 || isDisableBarId}
                              >
                                {/* <option value={''}>Select Bar Quantity</option> */}
                                {BarList.length > 0 &&
                                  BarList.map((data) => (
                                    <option key={data.BarQuantity} value={data.BarQuantity}>
                                      {data.BarQuantity}
                                    </option>
                                  ))}
                              </select>
                              <label className="mt-2">CFM Quantity</label>
                              <select
                                className="form-control"
                                value={CFMId}
                                onChange={(e) => this.onCFM_Qantity(e)}
                                disabled={Is_View || isDeadlinePassed || StatusID == 2 || isDisableCFMId}
                              >
                                {/* <option value={''}>Select CFM Quantity</option> */}
                                {CFMList.length > 0 &&
                                  CFMList.map((data) => (
                                    <option key={data.CFMID} value={data.CFMID}>
                                      {data.CFM}
                                    </option>
                                  ))}
                              </select>
                            </td>
                          </tr>
                        </tbody>
                        <thead>
                          <tr>
                            <th style={{ width: "25%" }}>Description of Service</th>
                            <th style={{ width: "25%" }}>Max Compressed Air</th>
                            {!isHideSection && (
                              <th style={{ width: "25%" }}>
                                Rates {CurrencyID == 1 ? "(INR)" : "(USD)"}
                              </th>
                            )}
                            {/* <th style={{ width: '25%' }}>Quantity</th> */}
                            {!isHideSection && (
                              <th style={{ width: "25%" }}>
                                Amount {CurrencyID == 1 ? "(INR)" : "(USD)"}
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>No. of Connections required</td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={MaxCompressedQuantity}
                                onChange={(e) =>
                                  this.setState({
                                    MaxCompressedQuantity: e.target.value.replace(/\D/, ""),
                                    Amount: Rates * e.target.value.replace(/\D/, ""),
                                    totalAmount: Rates * e.target.value.replace(/\D/, ""),
                                  })
                                }
                                maxLength={2}
                                disabled={Is_View || isDeadlinePassed || StatusID == 2 || isDisableMaxCompress}
                              // disabled={true}
                              />
                            </td>
                            {!isHideSection && (
                              <td style={{ textAlign: "right" }}>{formatAmount(Rates)}</td>
                            )}
                            {/* <td>
                                                            <input type="text" className="form-control"
                                                                value={Quantity}
                                                                onChange={(e) => this.setState({ Quantity: e.target.value.replace(/\D/, '') })}
                                                                maxLength={10}
                                                                disabled={Is_View}
                                                            />
                                                        </td> */}
                            {!isHideSection && (
                              <td style={{ textAlign: "right" }}>
                                {formatAmount(Amount != "" && Amount != null ? Amount : 0)}
                              </td>
                            )}
                          </tr>
                          <tr>
                            {!isHideSection && (
                              <>
                                <td colSpan={2}></td>
                                <td>
                                  <strong>Total</strong>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <strong>{formatAmount(totalAmount)}</strong>
                                </td>
                              </>
                            )}
                          </tr>
                          {!isHideSection &&
                            (!IsIGST ? (
                              <>
                                <tr>
                                  <td colspan="2"></td>
                                  <td>
                                    <strong>CGST @ {CGST}%</strong>
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    <strong>{formatAmount((CGST / 100) * totalAmount)}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="2"></td>
                                  <td>
                                    <strong>SGST @ {SGST}%</strong>
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    <strong>{formatAmount((SGST / 100) * totalAmount)}</strong>
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <tr>
                                <td colspan="2"></td>
                                <td>
                                  <strong>IGST @ {IGST}%</strong>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <strong>{formatAmount((IGST / 100) * totalAmount)}</strong>
                                </td>
                              </tr>
                            ))}
                          {!isHideSection && (
                            <tr style={{ backgroundcolor: "#eee" }}>
                              <td colSpan={2}></td>
                              <td>
                                <strong>Grand Total</strong>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <strong>
                                  {formatAmount(
                                    (CGST / 100) * totalAmount +
                                    (SGST / 100) * totalAmount +
                                    totalAmount
                                  )}
                                </strong>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {!isHideSection && (
                  <div class="row m-1">
                    <form>
                      <strong>
                        {" "}
                        <label>Remark</label>
                      </strong>
                      <textarea
                        class="form-control"
                        value={Remark}
                        disabled={Is_View || isDeadlinePassed || StatusID == 2}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        maxLength={300}
                        rows="3"
                      ></textarea>
                      <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                        <input
                          type="checkbox"
                          checked={Is_Agree}
                          disabled={Is_View || isDeadlinePassed || StatusID == 2}
                          onChange={(e) =>
                            this.setState({
                              Is_Agree: e.target.checked,
                              Is_AgreeErr: "",
                            })
                          }
                        />
                        <strong>
                          {" "}
                          We hereby read & understood the above mentioned clauses & consequences. We
                          accept & agree to abide by the same
                          <span className="required">*</span>.
                        </strong>
                      </label>
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {Is_AgreeErr}
                        </span>
                      }
                    </form>
                  </div>
                )}
              </div>
              <div className="row">
                {isDeadlinePassed && (
                  <span className="text-danger">THE DEADLINE TO FILL OUT THE FORM HAS PASSED.</span>
                )}
              </div>
              {!isHideSection && (
                <div className="d-flex justify-content-end mt-0">
                  {!Is_View ? (
                    <button
                      type="button"
                      className="btn btn-aqua rounded-1 d-block"
                      style={{ marginRight: 10 }}
                      disabled={isDeadlinePassed || StatusID == 2}
                      // onClick={() => this.addAirConnection()}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                    >
                      {this.state.StatusID == 0 ? "Submit" : "Update"}
                    </button>
                  ) : (
                    <></>
                  )}
                  <button
                    className="btn btn-gray rounded-1 d-block"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    insertUpdateAirConnection_action,
    getAirConnectionDetails_action,
    fill_action,
  })(AirConnectionApplication)
);
